import React from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Sidebar from './Sidebar';

const Layout = ({ children }) => {
  const location = useLocation();

  return (
    <div className="flex min-h-screen pt-16">
      <Navbar />
      <Sidebar />
      <main className="flex-1 lg:mr-64 transition-all duration-300">
        <div key={location.pathname} className="animate-fade-in-up">
          {children}
        </div>
      </main>
    </div>
  );
};

export default Layout;

